<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="perfiles-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/perfiles']"
  >
    &nbsp;>&nbsp;{{ labels.perfiles }}
  </a>
</div>

<br /><br />

<div id="perfiles-main-container" class="container">
  <mat-card id="perfiles-card">
    <div id="perfiles-header" class="header-options">
      <div id="perfiles-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.perfiles }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openCreateModal()"
          matTooltip="{{ labels.createPerfil }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createPerfil }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <div class="filters-grid">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar perfiles</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (input)="searchPerfiles($any($event.target).value)"
              placeholder="Buscar por nombre..."
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Column filters -->
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Nombre</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.nombrePerfil"
              (input)="onColumnFilterChange('nombrePerfil', $any($event.target).value)"
              placeholder="Filtrar por nombre..."
            />
          </mat-form-field>
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="resetFilters()"
          style="height: 40px; align-self: center"
        >
          <mat-icon style="margin-right: 6px">filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>
    }

    <div id="perfiles-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>{{ labels.loadingPerfiles }}</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
        </div>
      } @else {
        <div class="table-wrapper">
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z2">
            <!-- ID Column -->
            <ng-container matColumnDef="perfilId">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableId }}</th>
              <td mat-cell *matCellDef="let perfil">
                {{ perfil.perfilId }}
              </td>
            </ng-container>

            <!-- Nombre Perfil Column -->
            <ng-container matColumnDef="nombrePerfil">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableNombrePerfil }}</th>
              <td mat-cell *matCellDef="let perfil">
                {{ perfil.nombrePerfil }}
              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
              <td mat-cell *matCellDef="let perfil">
                <div class="action-buttons">
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="openCreateModal(perfil)"
                    matTooltip="{{ labels.tooltipEdit }}"
                  >
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    color="warn"
                    (click)="selectPerfil(perfil); deletePerfil()"
                    matTooltip="{{ labels.tooltipDelete }}"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: displayedColumns"
              [class.selected-row]="selectedPerfil?.perfilId === row.perfilId"
            ></tr>
          </table>

          @if (dataSource.data.length === 0) {
            <div class="no-data-container">
              <mat-icon class="no-data-icon">inbox</mat-icon>
              <p class="no-data-message">No hay perfiles disponibles</p>
              <p class="no-data-submessage">Haga clic en "Crear Perfil" para agregar el primero</p>
            </div>
          }

          <mat-paginator
            #paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [showFirstLastButtons]="true"
            (page)="onPageChange($event)"
            aria-label="Seleccionar página de perfiles"
          ></mat-paginator>
        </div>
      }
    </div>
  </mat-card>
</div>

<!-- Create/Edit Modal -->
<ng-template #createPerfilModal>
  <h2 id="perfil-modal-title" mat-dialog-title>
    {{ isEditing ? labels.editPerfil : labels.createPerfil }}
  </h2>

  <mat-dialog-content id="perfil-modal-content" class="modal-content">
    <form id="perfil-form" [formGroup]="perfilForm">
      <!-- Nombre Perfil Field -->
      <mat-form-field
        appearance="outline"
        class="full-width"
        [errorStateMatcher]="errorStateMatcher"
      >
        <mat-label>{{ labels.nombrePerfil }}</mat-label>
        <input
          matInput
          formControlName="nombrePerfil"
          placeholder="Ingrese el nombre del perfil"
          maxlength="100"
          [class.error-field]="hasError('nombrePerfil')"
        />
        @if (hasError('nombrePerfil')) {
          <mat-error>{{ getErrorMessage('nombrePerfil') }}</mat-error>
        }
      </mat-form-field>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions id="perfil-modal-actions" align="end">
    <button
      id="save-perfil-button"
      mat-button
      mat-raised-button
      color="primary"
      (click)="savePerfil()"
      [disabled]="perfilForm.invalid"
    >
      <mat-icon>save</mat-icon>
      {{ labels.save }}
    </button>
    <button id="cancel-perfil-button" mat-button (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>
